import styled, { css } from 'styled-components';
import { COLORS } from '@app/constants';

interface ContainerProps {
  $isDragging: boolean;
  $textsilver: string;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  align-items: center;
  flex-direction: row;
  padding: 4px 12px;
  gap: 6px;
  flex-shrink: 0;
  cursor: ${({ $isDragging }) => ($isDragging ? 'grabbing' : 'pointer')};
  background-color: ${({ $isDragging, $textsilver }) =>
    $isDragging ? `${$textsilver}20` : 'transparent'};
`;

interface StarIconWrapperProps {
  $disabled: boolean;
}

export const StarIconWrapper = styled.svg<StarIconWrapperProps>`
  width: 14px;
  height: 14px;
  margin-right: 4px;
  opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};

  position: relative;
  bottom: 1px;
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
`;

export const PairsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  flex: 1;
`;

export const PairsText = styled.span`
  color: #e9e9ed;
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 11px;
  font-weight: 400;
  line-height: 1;
  letter-spacing: -0.33px;
`;

export const PriceContainer = styled.div`
  display: flex;
  flex-direction: row;
  cursor: pointer;
  justify-content: space-between;
  gap: 6px;
`;

export const PriceText = styled.span`
  color: #fff;
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 11px;
  font-weight: 400;
  line-height: 1;
  letter-spacing: -0.33px;
`;

interface ChangeTextProps {
  $isPositive: boolean;
}

export const ChangeText = styled.span<ChangeTextProps>`
  color: ${({ $isPositive }) => ($isPositive ? COLORS.green : COLORS.lightRed)};
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 11px;
  font-weight: 400;
  line-height: 1;
  letter-spacing: -0.33px;
`;

interface DragHandleProps {
  $textsilver: string;
}

export const DragHandle = styled.div<DragHandleProps>`
  cursor: grab;
  display: flex;
  align-items: center;
  padding: 0 2px;
  margin-right: 2px;

  svg {
    color: ${({ $textsilver }) => $textsilver};
  }
`;
